import { Desktop } from '@99designs/common/components/Desktop';
import { Mobile } from '@99designs/common/components/Mobile';
import { breakpoints } from '@99designs/common/core/settings';
import { DesignerCard_User } from '__generated__/DesignerCard_User';
import React, { useContext, useEffect, useState } from 'react';
import MediaQuery from 'react-responsive';
import BriefContext from './BriefContext';
import Card from './Card';
import DesignCarousel from './DesignCarousel';
import DesignerMeta from './DesignerMeta';
import FileOverlay from './FileOverlay';

export interface Props {
    user: DesignerCard_User;
    isSelected: boolean;
    onMount: () => void;
    children: React.ReactNode;
}

export default function DesignerCard(Props: Props) {
    const { user, isSelected, children } = Props;
    useEffect(() => {
        Props.onMount();
    }, []);

    const [isOverlayActive, updateIsOverlayActive] = useState(false);
    const [showFullBiography, updateShowFullBiography] = useState(false);
    const [activeDesign, updateActiveDesign] = useState(0);
    const { themeName } = useContext(BriefContext);
    const theme = themeName ? themeName : '';

    const cardVariations = ['designer-card', theme];
    return (
        <Card variations={isSelected ? [...cardVariations, 'selected'] : cardVariations}>
            <Card.Media>
                <MediaQuery minWidth={breakpoints.normal[0]}>
                    {matches => (
                        <DesignCarousel
                            designer={user}
                            isClickable={matches}
                            showPaginators={false}
                            onClick={() => {
                                updateIsOverlayActive(true);
                            }}
                            onChange={designIndex => {
                                updateActiveDesign(designIndex);
                            }}
                            selectedIndex={activeDesign}
                        />
                    )}
                </MediaQuery>
                {isOverlayActive && (
                    <FileOverlay
                        designer={user}
                        selectedDesignIndex={activeDesign}
                        onClose={() => updateIsOverlayActive(false)}
                        onDesignChange={designIndex => {
                            updateActiveDesign(designIndex);
                        }}
                    />
                )}
            </Card.Media>
            <Card.Block>
                <Desktop>
                    <DesignerMeta
                        designer={user}
                        onClickDescription={() => {
                            updateIsOverlayActive(true);
                        }}
                        isCompact={true}
                    />
                </Desktop>
                <Mobile>
                    <DesignerMeta
                        designer={user}
                        onClickDescription={() => {
                            updateShowFullBiography(!showFullBiography);
                        }}
                        showFullBiography={showFullBiography}
                    />
                </Mobile>
            </Card.Block>
            <Card.Block>{children}</Card.Block>
        </Card>
    );
}
